// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoices-main{
   width:calc(100vw - 202px);
   height: calc(100vh - 38px);
  
   background-color: #F4F9FF;
}

.invoice-div{
    background-color: #FFFFFF;
    margin-left: 15px;
    position: absolute;
    margin-top: 15px;
    width: calc(100vw - 265px);
    height: calc(100vh - 100px);
  
    padding: 20px;
    box-shadow: 0px 0px 7px lightblue;
    border-radius: 5px;
    border: none;
   
}



.invoices-min{
    width: calc(100vw - 100px);
    height: calc(100vh - 38px);
    background-color: #F4F9FF; 
}

.invoice-div-min{
    background-color: #FFFFFF;
    margin-left: 15px;
    position: absolute;
    margin-top: 15px;
    width: calc(100vw - 165px);
    height: calc(100vh - 100px);
    padding: 20px;
    box-shadow: 0px 0px 7px lightblue;
    border-radius: 5px;
    border: none;
}

.invoice-header{
    border-bottom: 2px solid lightgray;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    overflow: auto;
    padding-top: 10px;
}


.invoice-content{
   display: flex;
   flex-direction: column;
   margin-left: 0;
}

@media screen and (max-width:1200px) {
    .invoice-summary{
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
}

.invoice-table{
     width: 100%;
     height: calc( 100vh - 260px);
     background-color: #fcfcfc;
     margin-top: 10px;
     border: 1px solid #f6f8f9;
     border-radius: 10px;
     text-align: center;
     overflow-x: auto;
}

.invoice-table::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .invoice-table::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }


.invoice-table td{
    font-size: 11px !important;
    width: 200px;
}

.invoice-header-filter{
    display: flex;
    /* flex-direction: row; */
    align-items: center;
}

.invoice-summary{
    width: 100%;
    padding: 0;
    margin: 8px 0 0 0;
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 6px;
    overflow: visible;
    height: auto;
}

.invoice-clients{
    width: 100%;
    background-color: #fcfcfc;
    height: auto;
    min-height: 48px;
    border-radius: 6px;
    margin: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
    box-shadow: 0px 0px 4px lightblue;
}

.invoice-clients-value{
    font-size: 13px;
    font-weight: 600;
    line-height: 1.15;
    word-break: break-word;
}

.invoice-clients-label{
    color: darkblue;
    margin-top: 2px;
    font-size: 10px;
    line-height: 1.15;
}

.invoice-clients:hover{
    background-color: rgb(132, 214, 214);
    transform: scale(1.1);
    cursor: pointer;
}

/* .invoice-clients:nth-child(1):hover{
    background-color: rgb(132, 214, 214);
    transform: scale(1.1);
} */

.month-selector{
    width:200px !important;
    padding-left: 5px;
}

.monthInput{
      /* Add your custom styles here */
  width: 150px; /* Set the width of the input */
  padding: 10px; /* Add padding for spacing */
  border: 1px solid #ccc; /* Add a border */
  border-radius: 5px; /* Round the corners */
  font-size: 16px; /* Set the font size */
  outline: none; /* Remove the default focus outline */
  /* Add more styles as needed */
  cursor: pointer;
}

.invoice-header-filter>div{
    margin-right: 20px;
}

.search-div>div>input{
   padding:10px;
   z-index: 10;
} 

.invoice-header-filter>div>div>input{
    padding: 11px;
    font-size: 14px;
}

.table-invoice{
    margin-top: 20px;
}

.invoice-tbody th{

}

/* .table-invoice td{
   padding: 0px;
} */


/* .table-invoice th{
    padding: 0px;
 } */

.invoice-thead{
    position: sticky;
}

.invoice-thead>th{
   font-size: 12px;
   padding: 10px 5px;
   text-align: center;
}

/* .invoice-tbody{
    cursor: pointer;
} */

.invoice-tbody>td{
    font-size: 12px;
    padding: 7px 5px;
    text-align: center;
    background-color: inherit !important;
}

.invoice-tbody:hover{
    background-color: lightblue;
}

.invoice-tbody:hover .readmoreIcon{
   display: none !important;
}

.invoice-tbody:hover .firstreadmoreIcon{
    display: block !important;
    
}


/* Main invoice tab navigation */
.invoice-main-tabs {
    display: flex;
    border-bottom: 2px solid #e2e8f0;
    margin-bottom: 0;
    padding-bottom: 0;
}

.invoice-main-tab-item {
    padding: 10px 28px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #64748b;
    border-bottom: 2px solid transparent;
    margin-bottom: -2px;
    transition: color 0.15s, border-color 0.15s;
    -webkit-user-select: none;
            user-select: none;
}

.invoice-main-tab-item:hover {
    color: #1e40af;
}

.invoice-main-tab-active {
    font-weight: 600;
    color: #1e40af !important;
    border-bottom: 2px solid #1e40af !important;
}

/* Mail Tracker Styles */
.mail-tracker-container {
    padding: 5px 0;
}

.mail-tracker-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    gap: 8px;
    flex-wrap: wrap;
}

.mail-tracker-summary {
    display: flex;
    gap: 6px;
    align-items: center;
}

.mail-tracker-card {
    display: flex;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    padding: 4px 10px;
}

.mail-tracker-card-label {
    font-size: 10px;
    color: #64748b;
    font-weight: 500;
}

.mail-tracker-card-value {
    font-size: 14px;
    font-weight: 700;
}

.mail-tracker-filters {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/components/Invoice/Invoices.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;GACzB,0BAA0B;;GAE1B,yBAAyB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,2BAA2B;;IAE3B,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;;AAEhB;;;;AAIA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;AACrB;;;AAGA;GACG,aAAa;GACb,sBAAsB;GACtB,cAAc;AACjB;;AAEA;IACI;QACI,2DAA2D;IAC/D;AACJ;;AAEA;KACK,WAAW;KACX,4BAA4B;KAC5B,yBAAyB;KACzB,gBAAgB;KAChB,yBAAyB;KACzB,mBAAmB;KACnB,kBAAkB;KAClB,gBAAgB;AACrB;;AAEA;IACI,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;;AAGF;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;;GAGG;;AAEH;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;MACM,gCAAgC;EACpC,YAAY,EAAE,+BAA+B;EAC7C,aAAa,EAAE,4BAA4B;EAC3C,sBAAsB,EAAE,iBAAiB;EACzC,kBAAkB,EAAE,sBAAsB;EAC1C,eAAe,EAAE,sBAAsB;EACvC,aAAa,EAAE,qCAAqC;EACpD,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;GACG,YAAY;GACZ,WAAW;AACd;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;;GAEG;;;AAGH;;IAEI;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;GACG,eAAe;GACf,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;;GAEG;;AAEH;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;IACI,yBAAyB;;AAE7B;;;AAGA,gCAAgC;AAChC;IACI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,mBAAmB;IACnB,2CAA2C;IAC3C,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA,wBAAwB;AACxB;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".invoices-main{\n   width:calc(100vw - 202px);\n   height: calc(100vh - 38px);\n  \n   background-color: #F4F9FF;\n}\n\n.invoice-div{\n    background-color: #FFFFFF;\n    margin-left: 15px;\n    position: absolute;\n    margin-top: 15px;\n    width: calc(100vw - 265px);\n    height: calc(100vh - 100px);\n  \n    padding: 20px;\n    box-shadow: 0px 0px 7px lightblue;\n    border-radius: 5px;\n    border: none;\n   \n}\n\n\n\n.invoices-min{\n    width: calc(100vw - 100px);\n    height: calc(100vh - 38px);\n    background-color: #F4F9FF; \n}\n\n.invoice-div-min{\n    background-color: #FFFFFF;\n    margin-left: 15px;\n    position: absolute;\n    margin-top: 15px;\n    width: calc(100vw - 165px);\n    height: calc(100vh - 100px);\n    padding: 20px;\n    box-shadow: 0px 0px 7px lightblue;\n    border-radius: 5px;\n    border: none;\n}\n\n.invoice-header{\n    border-bottom: 2px solid lightgray;\n    padding-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n    overflow: auto;\n    padding-top: 10px;\n}\n\n\n.invoice-content{\n   display: flex;\n   flex-direction: column;\n   margin-left: 0;\n}\n\n@media screen and (max-width:1200px) {\n    .invoice-summary{\n        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n    }\n}\n\n.invoice-table{\n     width: 100%;\n     height: calc( 100vh - 260px);\n     background-color: #fcfcfc;\n     margin-top: 10px;\n     border: 1px solid #f6f8f9;\n     border-radius: 10px;\n     text-align: center;\n     overflow-x: auto;\n}\n\n.invoice-table::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .invoice-table::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n\n.invoice-table td{\n    font-size: 11px !important;\n    width: 200px;\n}\n\n.invoice-header-filter{\n    display: flex;\n    /* flex-direction: row; */\n    align-items: center;\n}\n\n.invoice-summary{\n    width: 100%;\n    padding: 0;\n    margin: 8px 0 0 0;\n    display: grid;\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    gap: 6px;\n    overflow: visible;\n    height: auto;\n}\n\n.invoice-clients{\n    width: 100%;\n    background-color: #fcfcfc;\n    height: auto;\n    min-height: 48px;\n    border-radius: 6px;\n    margin: 0;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 6px;\n    box-shadow: 0px 0px 4px lightblue;\n}\n\n.invoice-clients-value{\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.15;\n    word-break: break-word;\n}\n\n.invoice-clients-label{\n    color: darkblue;\n    margin-top: 2px;\n    font-size: 10px;\n    line-height: 1.15;\n}\n\n.invoice-clients:hover{\n    background-color: rgb(132, 214, 214);\n    transform: scale(1.1);\n    cursor: pointer;\n}\n\n/* .invoice-clients:nth-child(1):hover{\n    background-color: rgb(132, 214, 214);\n    transform: scale(1.1);\n} */\n\n.month-selector{\n    width:200px !important;\n    padding-left: 5px;\n}\n\n.monthInput{\n      /* Add your custom styles here */\n  width: 150px; /* Set the width of the input */\n  padding: 10px; /* Add padding for spacing */\n  border: 1px solid #ccc; /* Add a border */\n  border-radius: 5px; /* Round the corners */\n  font-size: 16px; /* Set the font size */\n  outline: none; /* Remove the default focus outline */\n  /* Add more styles as needed */\n  cursor: pointer;\n}\n\n.invoice-header-filter>div{\n    margin-right: 20px;\n}\n\n.search-div>div>input{\n   padding:10px;\n   z-index: 10;\n} \n\n.invoice-header-filter>div>div>input{\n    padding: 11px;\n    font-size: 14px;\n}\n\n.table-invoice{\n    margin-top: 20px;\n}\n\n.invoice-tbody th{\n\n}\n\n/* .table-invoice td{\n   padding: 0px;\n} */\n\n\n/* .table-invoice th{\n    padding: 0px;\n } */\n\n.invoice-thead{\n    position: sticky;\n}\n\n.invoice-thead>th{\n   font-size: 12px;\n   padding: 10px 5px;\n   text-align: center;\n}\n\n/* .invoice-tbody{\n    cursor: pointer;\n} */\n\n.invoice-tbody>td{\n    font-size: 12px;\n    padding: 7px 5px;\n    text-align: center;\n    background-color: inherit !important;\n}\n\n.invoice-tbody:hover{\n    background-color: lightblue;\n}\n\n.invoice-tbody:hover .readmoreIcon{\n   display: none !important;\n}\n\n.invoice-tbody:hover .firstreadmoreIcon{\n    display: block !important;\n    \n}\n\n\n/* Main invoice tab navigation */\n.invoice-main-tabs {\n    display: flex;\n    border-bottom: 2px solid #e2e8f0;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\n.invoice-main-tab-item {\n    padding: 10px 28px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 400;\n    color: #64748b;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -2px;\n    transition: color 0.15s, border-color 0.15s;\n    user-select: none;\n}\n\n.invoice-main-tab-item:hover {\n    color: #1e40af;\n}\n\n.invoice-main-tab-active {\n    font-weight: 600;\n    color: #1e40af !important;\n    border-bottom: 2px solid #1e40af !important;\n}\n\n/* Mail Tracker Styles */\n.mail-tracker-container {\n    padding: 5px 0;\n}\n\n.mail-tracker-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.mail-tracker-summary {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n\n.mail-tracker-card {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    border-radius: 6px;\n    padding: 4px 10px;\n}\n\n.mail-tracker-card-label {\n    font-size: 10px;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.mail-tracker-card-value {\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.mail-tracker-filters {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    flex-wrap: wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
